var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sendEmailTransfer" } },
    [
      _c("div", { staticClass: "tab-transfer" }, [
        _vm._v(_vm._s(_vm.$t("language.popup.chooseAction")))
      ]),
      _vm._v(" "),
      _c("cloud-select", {
        ref: "cloudSelect",
        staticStyle: { "margin-bottom": "40px" },
        attrs: {
          widthVal: 400,
          selectOption: _vm.selectOption,
          placeholder: _vm.placeholderValue
        },
        on: { changeOption: _vm.onChangeOption }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "check-item-positions" }, [
        _c("div", {
          staticClass: "icon-util",
          class: [_vm.isSaveAtt ? "check-small" : "nocheck-small-blue"],
          staticStyle: { float: "left" },
          on: {
            click: function($event) {
              _vm.isSaveAtt = !_vm.isSaveAtt
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "check-item-position" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.emailTransfer.saveAtt")))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check-item-positions" }, [
        _c("div", {
          staticClass: "icon-util",
          class: [_vm.isConver ? "check-small" : "nocheck-small-blue"],
          staticStyle: { float: "left" },
          on: {
            click: function($event) {
              _vm.isConver = !_vm.isConver
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "check-item-position" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("language.emailTransfer.converFormat")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-util question-mark" }, [
            _c("div", { staticClass: "plan-questionTxt" }, [
              _vm._v(_vm._s(_vm.$t("language.emailTransfer.converFormatTip")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check-item-positions" }, [
        _c("div", {
          staticClass: "icon-util",
          class: [_vm.isSaveOnly ? "check-small" : "nocheck-small-blue"],
          staticStyle: { float: "left" },
          on: {
            click: function($event) {
              _vm.isSaveOnly = !_vm.isSaveOnly
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "check-item-position" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("language.emailTransfer.saveOnly")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check-item-positions" }, [
        _c("div", {
          staticClass: "icon-util",
          class: [_vm.isChar == 1 ? "check-small" : "nocheck-small-blue"],
          staticStyle: { float: "left" },
          on: {
            click: function($event) {
              _vm.isChar == 1 ? (_vm.isChar = 0) : (_vm.isChar = 1)
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "check-item-position" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.popup.automaRename")))]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-util question-mark" }, [
            _c("div", { staticClass: "plan-questionTxt" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.optionsPrompt")))
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-339ffece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339ffece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_email_transfer.vue
// module id = null
// module chunks = 